module.exports = __webpack_public_path__ + "media/Mantraz_Web_1080p.4dbb9d73.webm";